<template>
    <div style="display: flex; flex-direction: column; font-weight: 500;">
        <div v-if="!isResult" style="padding-left: 12px; font-weight: 700; font-size: 20px; margin-top: 25px;">검색</div>
        <div style="padding: 0 12px; margin-top: 20px; display: flex; gap: 12px;">
            <div style="margin-top: 12px;" @click="() => { $GlobalStore.closeLastModal() }" v-if="isResult">
                <img style="width: 10px;" :src="require('@/assets/img/back_btn_black.png')" alt="">
            </div>
            <div style="flex: 1;">
                <MercenarySearchInput :enter="enter" :searchWord="searchWord" :setSearchWord="setSearchWord" :isShowCancelBtn="!isResult" :clickCancel="() => { $GlobalStore.closeLastModal() }" :placeholder="'검색'"></MercenarySearchInput>
                <div v-if="isResult" style="margin-top: 12px; padding-bottom: 9px; display: flex; gap: 4px;">
                    <div @click="setBtnType(each.value)" v-for="each, i in btnList" :key="i" :class="each.value === curType ? 'active' : ''" class="common_btn">{{ each.name }}</div>
                </div>
            </div>
        </div>
        <div v-if="isResult" style="height: 1px; background-color: #f5f5f5; width: 100%;"></div>
        <div v-if="!isResult" style="flex: 1; overflow-y: scroll; margin-top: 24px; padding: 0 12px;">
            <div style="font-weight: 700; line-height: 24px;">최근 검색어</div>
            <div style="">
                <div @click="enter({ keyCode: 13, target: { value: each.keyword } })" v-for="each, i in keywordList" :key="i" style="display: flex; border-bottom: 1px solid #ebebeb; padding: 12px 0; justify-content: space-between; align-items: center;">
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <img style="width: 30px;" :src="require('@/assets/img/recent_search.png')" alt="">
                        <div style="line-height: 24px;">{{ each.keyword }}</div>
                    </div>
                    <img @click.stop="deleteKeywordList(each.idx, i)" style="width: 11px;" :src="require('@/assets/img/x_btn_gray.png')" alt="">
                </div>
            </div>
        </div>
        <div style="flex: 1; overflow-y: hidden; padding: 0 12px;" v-else>
            <template v-if="isExistSearchResult">
                <InfinityScroll :isNeedXHidden="true" :handle-next-page="handleNextPage" :is-enable-next-page-handle="isEnableNextPageHandle" :refresh-action="() => { }" style="height: 100%;">
                    <template v-if="curType === BTN_TYPE.POST">
                        <div style="border-bottom: 1px solid #f5f5f5; padding: 20px 0;" v-for="each, i in soccerHows" :key="i + 'soccerhow'">
                            <CommonPost :hideOption="true" :isExpertConfirmed="true" :isExpert="false" :isFeed="true" :soccerHows="each"></CommonPost>
                        </div>
                    </template>
                    <template v-else-if="curType === BTN_TYPE.PROFILE">
                        <div v-for="each, i in profileList" :key="i + 'profile'" style="padding: 20px 0; border-bottom: 1px solid #ebebeb;">
                            <CommonProfile :memberInfo="each"></CommonProfile>
                        </div>
                    </template>
                    <template v-else-if="curType === BTN_TYPE.MEMBER_TALK">
                        <div @click="joinMemberTalkConfirm(each, i)" style="border-bottom: 1px solid #f5f5f5; padding: 20px 0;" v-for="each, i in memberTalkList" :key="i + 'member_talk'">
                            <div style="display: flex;  gap: 8px;">
                                <div style="width: 40px; height: 40px; border-radius: 8px; border: 2px solid #d9d9d9; overflow: hidden;">
                                    <img style="object-fit: cover; width: 100%; height: 100%;" :src="$resourcePath + each.thumbnail_path" alt="">
                                </div>
                                <div>
                                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">{{ each.title }}</div>
                                    <div style="color: #808080; font-weight: 500; font-size: 12px; line-height: 20px; display: flex; align-items: center; gap: 4px;">{{ each.join_tag }} <span style="width: 2px; height: 2px; border-radius: 50%; background-color: #808080;"></span>{{ each.age }}</div>
                                    <div style="font-weight: 500; font-size: 12px; line-height: 20px;">{{ each.cur_cnt }}명 참여중</div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="curType === BTN_TYPE.TRAINING">
                        <div @click="showTrainingDetail(each.idx)" style="border-bottom: 1px solid #f5f5f5; padding: 20px 0;" v-for="each, i in trainingList" :key="i + 'training'">
                            <div style="display: flex;  gap: 8px;">
                                <div style="width: 40px; height: 40px; border-radius: 8px; border: 2px solid #d9d9d9; overflow: hidden;">
                                    <img style="object-fit: cover; width: 100%; height: 100%;" :src="each.slider_images.length > 0 ? $resourcePath + each.slider_images[0].thumb_image_path : require('@/assets/img/test_back.png')" alt="">
                                </div>
                                <div>
                                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">{{ each.title }}</div>
                                    <div style="display: flex; align-items: center; gap: 4px;">
                                        <div style="font-size: 12px; font-weight: 500; line-height: 20px; color: #808080;">{{ each.creator.nic_name }}</div>
                                        <img v-if="each.creator.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 14px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                        <img v-else style="width: 14px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                    </div>
                                    <div style="font-weight: 500; font-size: 12px; line-height: 20px;  display: flex; align-items: center; gap: 4px;">{{ $Util.getMMDDDayHangulStr(each.join_begin_date_time) }} <span style="width: 2px; height: 2px; border-radius: 50%; background-color: #808080;"></span> {{ each.place_name }}</div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="curType === BTN_TYPE.SOCCER_TEAM">
                        <div @click="showSoccerTeamDetail(each.idx)" style="border-bottom: 1px solid #f5f5f5; padding: 20px 0;" v-for="each, i in soccerTeamList" :key="i + 'soccer_team'">
                            <div style="display: flex;  gap: 8px;">
                                <div style="width: 40px; height: 40px; border-radius: 8px; border: 2px solid #d9d9d9; overflow: hidden;">
                                    <img style="object-fit: cover; width: 100%; height: 100%;" :src="$resourcePath + each.image_path" alt="">
                                </div>
                                <div>
                                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">{{ each.name }}</div>
                                    <div style="display: flex; align-items: center; gap: 4px;">
                                        <div style="font-size: 12px; font-weight: 500; line-height: 20px; color: #808080;">{{ each.manager.name }} 감독</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                </InfinityScroll>
            </template>
            <template v-else>
                <div style="display: flex; gap: 4px; align-items: center; margin-top: 20px; justify-content: center;">
                    <div>
                        <img style="width: 14px;" :src="require('@/assets/img/empty_search.png')" alt="">
                    </div>
                    <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #808080;">
                        검색 결과가 없습니다
                    </div>
                </div>
            </template>
        </div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="232" :changeHeightUnit="'px'" :isOpen="isShowModal" :closeCompleteAction="closeModal">
            <div style="padding: 16px 20px;">
                <div @click="closeModal" style="font-weight: 700;">닫기</div>
                <div style="margin-top: 32px; font-size: 20px; font-weight: 700; text-align: center;">멤버톡에 참여할까요?</div>
                <div @click="enterJoin" style="border-radius: 40px; margin: 0 auto; margin-top: 40px; width: 186px; height: 56px; line-height: 56px; background-color: #210f03; text-align: center; font-size: 14px; color: var(--color-main); font-weight: 700;">참여하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import MercenarySearchInput from '@/components/common/MercenarySearchInput'
import ResponseCode from '@/ResponseCode'
import InfinityScroll from '@/components/common/InfinityScroll'
import CommonPost from '@/components/soccerhowmain/CommonPost'
import { PAGE_NAME, JOIN_STATE, JOIN_CHAT_TYPE, MEMBER_TYPE, TEAM_TYPE } from '@/Constants'
import CommonProfile from '@/components/common/CommonProfile'
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'

const BTN_TYPE = {
    POST: '게시물',
    PROFILE: '프로필',
    MEMBER_TALK: '멤버톡',
    TRAINING: '트레이닝',
    SOCCER_TEAM: '축구팀'
}

export default {
    name: 'IntergrationSearch',
    components: { MercenarySearchInput, CommonPopupFrame, InfinityScroll, CommonPost, CommonProfile },
    props: {
        completeAction: {
            type: Function,
            default: () => { }
        },
        pageName: {
            type: String,
            default: PAGE_NAME.HOME
        },
        isResult: {
            type: Boolean,
            default: false
        },
        resultSearchWord: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            keywordList: [],
            searchWord: '',
            page: 1,
            curType: BTN_TYPE.POST,
            BTN_TYPE: BTN_TYPE,
            btnList: [],
            isEnableNextPageHandle: false,
            soccerHows: [],
            memberTalkList: [],
            trainingList: [],
            soccerTeamList: [],
            profileList: [],
            PAGE_NAME: PAGE_NAME,
            isExistSearchResult: false,
            detailInfo: {},
            isShowModal: false,
            TEAM_TYPE: TEAM_TYPE
        }
    },
    methods: {
        async enterJoin() {
            this.$GlobalStore.showProgress()
            const formData = new FormData
            formData.append('join_idx', this.detailInfo.idx);
            // if (password) formData.append('password', password);
            const res = await this.$Axios.post('/api/join/member/apply', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

            this.$GlobalStore.hideProgress()
            if (res.data.code === ResponseCode.SUCCESS) {
                this.closeModal()
                this.showChat({ chat_idx: res.data.chat_idx, idx: this.detailInfo.idx }, this.curIndex, true)
            } else if (res.data.code === ResponseCode.FAIL) {
                alert(res.data.msg)
            }
        },
        closeModal() {
            this.isShowModal = false
            this.detailInfo = {}
        },
        joinMemberTalkConfirm(detailInfo, i) {
            this.detailInfo = detailInfo
            console.log(detailInfo)
            if (this.detailInfo.is_me_joined) {
                this.showChat(this.detailInfo, i, true)
                return
            }
            this.isShowModal = true
        },
        async showJoinChat(chat_idx) {
            await this.$Axios.showChattingBySoccerJoinIdx(chat_idx, this.getChattings, false, async () => { });
        },
        async showChat(each, i, is_join = false) {
            this.$Util.sendEventClick('멤버_멤버톡_채팅보기')
            if (each.type == JOIN_CHAT_TYPE.SINGLE && each.single_member_type && each.single_member_type == MEMBER_TYPE.USER && each.target_member_idx == this.$Util.getAdminMemberIdx()) {
                this.$Util.showChatWithAdmin();
            } else if (each.type == JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT) {
                await this.$Axios.showPersonalChat(this.$Util.getAdminMemberIdx(), MEMBER_TYPE.USER, JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT);
            } else {
                this.showJoinChat(each.chat_idx, each.title, each.idx, i, is_join);
            }
        },
        showSoccerTeamDetail(idx) {
            this.$GlobalStore.addModal('SoccerTeamDetail', { teamIdx: idx })
        },
        showTrainingDetail(idx) {
            this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: idx })
        },
        handleNextPage() {
            this.page++
            this.searchApiCall(false)
        },
        searchApiCall(isChangeType) {
            if (this.curType === BTN_TYPE.POST) {
                this.searchHomeAPI(isChangeType)
            } else if (this.curType === BTN_TYPE.MEMBER_TALK) {
                this.searchMemberTalkAPI(isChangeType)
            } else if (this.curType === BTN_TYPE.TRAINING) {
                this.searchTrainingAPI(isChangeType)
            } else if (this.curType === BTN_TYPE.SOCCER_TEAM) {
                this.searchSoccerTeamAPI(isChangeType)
            } else if (this.curType === BTN_TYPE.PROFILE) {
                this.searchProfileAPI(isChangeType)
            }
        },
        async getKeywordList() {
            const res = await this.$Axios.get('/api/home/keyword/list')
            this.keywordList = res.data.keywords
        },
        async deleteKeywordList(idx, index) {
            const formData = new FormData()
            formData.append('idx', idx)

            const res = await this.$Axios.post('/api/home/keyword/delete', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$delete(this.keywordList, index)
            }
        },
        setBtnType(type) {
            this.page = 1;
            this.curType = type;
            this.isEnableNextPageHandle = true;
            this.searchApiCall(true)
        },
        setSearchWord(searchWord) {
            this.searchWord = searchWord
        },
        enter(e) {
            if (e.keyCode === 13) {
                this.searchWord = e.target.value
                this.saveKeyWord();
                if (!this.isResult) {
                    this.$GlobalStore.closeLastModal();
                    this.$nextTick(() => {
                        this.$GlobalStore.addModal('IntergrationSearch', { pageName: this.pageName, isResult: true, resultSearchWord: this.searchWord })
                    });

                } else {
                    this.page = 1;
                    this.searchApiCall(true)
                }
            }
        },
        async saveKeyWord() {
            if (this.searchWord === '') return;
            const parameters = {};
            parameters.searchWord = this.searchWord;
            await this.$Axios.post('/api/home/keyword/save', parameters);
        },
        setIsExistSearchResult(arr) {
            if (this.page === 1) {
                if (arr.length === 0) {
                    this.isExistSearchResult = false
                } else {
                    this.isExistSearchResult = true
                }
            }
        },
        async searchHomeAPI(isChangeType) {
            if (isChangeType) {
                this.soccerHows = []
            }
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.searchWord = this.searchWord;
            parameters.page = this.page;
            parameters.is_except_exit_member = true;

            const res = await this.$Axios.get('/api/soccerhow/list', { params: parameters })

            const soccerHows = res.data.soccerHows

            if (soccerHows.length > 0) {
                this.isEnableNextPageHandle = true
                this.soccerHows = [...this.soccerHows, ...soccerHows]
            }
            this.setIsExistSearchResult(this.soccerHows)
        },
        async searchTrainingAPI(isChangeType) {
            if (isChangeType) {
                this.trainingList = []
            }
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.searchWord = this.searchWord
            parameters.page = this.page
            parameters.is_limit = true
            parameters.is_without_paging = false;
            parameters.is_with_creator = true

            const res = await this.$Axios.get('/api/find/team/map/list', { params: parameters })

            const trainingList = res.data.schedules

            if (trainingList.length > 0) {
                this.isEnableNextPageHandle = true
                this.trainingList = [...this.trainingList, ...trainingList]
            }
            this.setIsExistSearchResult(this.trainingList)

        },
        async searchMemberTalkAPI(isChangeType) {
            if (isChangeType) {
                this.memberTalkList = []
            }
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.page = this.page
            parameters.state = JOIN_STATE.OPEN
            parameters.is_with_members = true
            parameters.is_with_chat = true
            parameters.searchWord = this.searchWord

            const res = await this.$Axios.get('/api/join/list', { params: parameters })
            const joinList = res.data.joins

            if (joinList.length > 0) {
                this.isEnableNextPageHandle = true
                this.memberTalkList = [...this.memberTalkList, ...joinList]
            }
            this.setIsExistSearchResult(this.memberTalkList)
        },
        async searchSoccerTeamAPI(isChangeType) {
            if (isChangeType) {
                this.soccerTeamList = []
            }
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.searchWord = this.searchWord

            const res = await this.$Axios.get('/api/team/map/list', { params: parameters })

            const soccerTeamList = res.data.teams
            this.soccerTeamList = soccerTeamList
            this.setIsExistSearchResult(this.soccerTeamList)
        },
        async searchProfileAPI(isChangeType) {
            if (isChangeType) {
                this.profileList = []
            }
            this.isEnableNextPageHandle = false

            const parameters = {}
            parameters.page = this.page;
            parameters.searchWord = this.searchWord;

            const res = await this.$Axios.get('/api/member/list', { params: parameters })
            const profileList = res.data.members

            if (profileList.length > 0) {
                this.isEnableNextPageHandle = true
                this.profileList = [...this.profileList, ...profileList]
            }
            this.setIsExistSearchResult(this.profileList)
        }

    },
    created() {
        if (!this.$GlobalStore.isLogin()) {
            return
        }

        if (this.isResult) {
            this.searchWord = this.resultSearchWord
            if (this.pageName === PAGE_NAME.HOME) {
                this.searchHomeAPI()
            } else if (this.pageName === PAGE_NAME.TRAINING) {
                this.curType = BTN_TYPE.TRAINING
                this.searchTrainingAPI()
            } else if (this.pageName === PAGE_NAME.MEMBER_TALK) {
                this.curType = BTN_TYPE.MEMBER_TALK
                this.searchMemberTalkAPI()
            } else if (this.pageName === PAGE_NAME.SOCCER_TEAM) {
                this.curType = BTN_TYPE.SOCCER_TEAM
                this.searchSoccerTeamAPI()
            }
        } else {
            this.getKeywordList()
        }
        const isCoach = this.$GlobalStore.loginInfo().is_temp_coach == 1 ? true : false

        if (isCoach) {
            this.btnList = [
                { name: '게시물', value: BTN_TYPE.POST },
                { name: '프로필', value: BTN_TYPE.PROFILE },
                { name: '트레이닝', value: BTN_TYPE.TRAINING },
                { name: '축구팀', value: BTN_TYPE.SOCCER_TEAM },
            ]
        } else {
            this.btnList = [
                { name: '게시물', value: BTN_TYPE.POST },
                { name: '프로필', value: BTN_TYPE.PROFILE },
                { name: '멤버톡', value: BTN_TYPE.MEMBER_TALK },
                { name: '트레이닝', value: BTN_TYPE.TRAINING },
                { name: '축구팀', value: BTN_TYPE.SOCCER_TEAM },
            ]
        }
    }
}
</script>

<style scoped>
.common_btn {
    padding: 4px 12px;
    line-height: 24px;
    font-weight: 500;
    font-size: 12px;
    text-align: center;
    text-align: center;
    border-radius: 20px;
    background-color: #fff;
    color: #606060;
}

.active {
    background-color: #210f03;
    color: #fff;
}
</style>